export default __webpack_public_path__ + "static/media/bootstrap.b74e54d4.png";